"use client";

import React from "react";
import { Github, Mail } from "lucide-react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex flex-col items-center p-4 sm:p-8 font-sans">
      {/* Privacy Policy Content Section */}
      <main className="w-full max-w-7xl py-12 md:py-20 px-4 text-left">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 leading-tight mb-4">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-orange-500">
            Privacy Policy
          </span>
        </h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: October 26, 2023</p>

        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold mb-2">Introduction</h2>
            <p className="text-lg">
              Welcome to our application. We are committed to protecting your privacy and handling your data in an open and transparent manner. This Privacy Policy explains how we collect, use, and protect your information when you use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">Information We Collect</h2>
            <p className="text-lg">
              We collect information you provide directly to us, such as your name, email address, and any other information you provide when you use our service, including the content you generate with our AI tools.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">How We Use Your Information</h2>
            <p className="text-lg">
              We use the information we collect to operate, maintain, and provide the features and functionality of our service, to improve our platform, and to communicate with you about your account. We will not sell your personal information to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">Data Security</h2>
            <p className="text-lg">
              We take reasonable measures to protect the information we collect from unauthorized access, use, or disclosure. However, no internet transmission is entirely secure, and we cannot guarantee the security of your information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-2">Changes to This Policy</h2>
            <p className="text-lg">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>
        </div>
      </main>

      {/* Footer Section */}
      <footer className="w-full max-w-7xl flex flex-col items-center py-8 px-4 border-t border-gray-200 mt-12">
        <div className="flex space-x-6 text-gray-500 mb-4">
          <a href="#" className="hover:text-teal-600 transition" aria-label="GitHub">
            <Github size={24} />
          </a>
          <a href="#" className="hover:text-teal-600 transition" aria-label="Email">
            <Mail size={24} />
          </a>
        </div>
        <p className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} LoR App. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Privacy;
